import React from 'react';
import Templates from '../modules/sms/templates/templates';

function SMSTemplates(){
  return <Templates/>
}

export default SMSTemplates;